import {handleResponse} from "./handle-response";
import axios from "axios";
import {authenticationService} from "../_services";
import moment from "moment";
import {history} from "./history";
import { showToastCustom } from '../../components/toast/customToast'
import {
    success,
    warning,
    error,
    saveMsg,
    updateMsg,
    deleteMsg,
    infoMsg,
    deleteErrorMsg, fbPathNotFound,
} from "../../components/i18n/i18n";
import {appEnvironment} from "../../appEnv";

let isAsociateRecords = false;

let environment = "";

const apiEnv = {
    develop: 'http://localhost:8080/',
    test: 'https://xkynet-dev-api.xcaret.com/',
    production: 'https://xkynet-api.xcaret.com/',
}

const webEnv = {
    develop: 'http://localhost:3000/',
    test: 'https://xkynet-dev.xcaret.com/',
    production: 'https://xkynet.xcaret.com/',
}

export const utilHelper = {
    hasAssociateRecords,
    restartAssociateRecords,
    doRequest,
    doIncognitoRequest,
    doRequestHandleResponse,
    doRequestFile,
    baseEndPoint,
    baseEndPointWeb,
    hexToRGB,
    dateFormatter,
    datetimeFormatter,
    dateSeasonFormatter,
    isDevelopEnvironment,
    calendarDateFormatter,
    doRequestFileHandleResponse,
    formatDateToString,
    getDateDaysAgo
};


function formatDateToString(dateValue, format = "YYYY-MM-DD") {
    if (!dateValue) {
        return "";
    }
    return `${moment(dateValue).format(format) ? moment(dateValue).format(format) : moment(dateValue).format(format)}`;
}


function getDateDaysAgo(daysAgo) {
    let date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date;
}

async function doRequest(url, method, data = null, head = null) {
    let api = axios.create({
        baseURL: baseEndPoint(),
        responseType: "json",
    })

    let currentUser = authenticationService.currentUserValue;
    const options = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': currentUser.access_token
        }
    };

    if (head != null) {
        options.headers = head;
    }

    if (data != null) {
        options.data = JSON.stringify(data);
    }

    return await api(url, options)
        .then(handleResponse)
        .catch(errorResponse => {
            switch (errorResponse.response?.status) {
                case 401:
                    history.push("/authentication/login");
                    localStorage.setItem('currentUser', null);
                    return;
                case 404:
                    history.push("/404");
                    return;
                case 300:
                    isAsociateRecords = true;
            }
        });
}

async function doIncognitoRequest(url, method) {
    let api = axios.create({
        baseURL: baseEndPoint(),
        responseType: "json",
    })

    const options = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return await api(url, options)
        .then(handleResponse)
        .catch(errorResponse => {
            switch (errorResponse.response?.status) {
                case 401:
                    history.push("/authentication/login");
                    localStorage.setItem('currentUser', null);
                    return;
                case 404:
                    history.push("/404");
                    return;
                case 300:
                    isAsociateRecords = true;
            }
        });
}




async function doRequestHandleResponse(url, method, {
    data = null,
    head = null,
    showAlert = true,
    message = null
}) {
    let response
    let responseData
    let api = axios.create({
        baseURL: baseEndPoint(),
        responseType: "json",
    })

    let currentUser = authenticationService.currentUserValue;
    const options = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': currentUser.access_token
        }
    };

    if (head != null)
        options.headers = head;

    if (data != null)
        options.data = JSON.stringify(data);

    try {
        response = await api(url, options)
        responseData = response?.data

        if(showAlert){
            switch(response.status){
                case 201:
                    showToastCustom("success", saveMsg)
                    break;
                case 200:
                    showToastCustom("success", message || updateMsg)
                    break;
                case 204:
                    responseData = { status:true }
                    showToastCustom(warning, deleteMsg, true);
                    break;
                case 300:
                    showToastCustom(error, deleteErrorMsg, true);
                    break
                case 400:
                    showToastCustom(error, infoMsg, true);
                    break;
                case 401:
                    history.push("/authentication/login");
                    localStorage.setItem('currentUser', null);
                    break
                case 402:
                case 404:
                case 422:
                case 500:
                    showToastCustom(error, infoMsg, true);
                    break;
                case 406:
                    showToastCustom(warning, infoMsg, true);
                    break;
                case 520:
                    showToastCustom(error, fbPathNotFound, true);
                    break;
                default:
                    break;
            }

            return responseData
        }
    } catch(errorMessage) {
        console.log("errorMessage", errorMessage);

        switch (errorMessage.response?.status) {
            case 400:
                showAlert && showToastCustom(error, infoMsg, true);
                break
            case 401:
                history.push("/authentication/login");
                localStorage.setItem('currentUser', null);
                break;
            case 404:
                history.push("/404");
                break;
            case 300:
                isAsociateRecords = true;
        }

        responseData = { status: false, message: errorMessage.response?.data?.message }
    }

    return responseData
}


async function doRequestFileHandleResponse(url, method, formData) {
    let responseData

    let api = axios.create({
        baseURL: baseEndPoint(),
        responseType: "json",
    })

    let currentUser = authenticationService.currentUserValue;
    const options = {
        method: method,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Auth-Token': currentUser.access_token
        }
    };

    try {
        let response = await api(url, options)
        responseData = response.data
        switch(response.status){
            case 201:
                showToastCustom(success, saveMsg)
                break;
            case 200:
                showToastCustom(success, updateMsg)
                break;
            case 204:
                showToastCustom(warning, deleteMsg, true);
                break;
            case 300:
                showToastCustom(error, deleteErrorMsg, true);
            case 400:
                showToastCustom(error, infoMsg, true);
                break;
            case 401:
                history.push("/authentication/login");
                localStorage.setItem('currentUser', null);
                break
            case 500:
                showToastCustom(error, infoMsg, true);
                break;
            default:
                break;
        }
    } catch(errorMessage) {
        switch (errorMessage.response?.status) {
            case 401:
                history.push("/authentication/login");
                localStorage.setItem('currentUser', null);
                return;
            case 404:
                history.push("/404");
                return;
            case 300:
                isAsociateRecords = true;
        }
    }

    return responseData
}





async function doRequestFile(url, method, formData) {
    let api = axios.create({
        baseURL: baseEndPoint(),
        responseType: "json",
    })

    let currentUser = authenticationService.currentUserValue;
    const options = {
        method: method,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Auth-Token': currentUser.access_token
        }
    };

    return await api(url, options)
        .then(handleResponse)
        .catch(errorResponse => {
            switch (errorResponse.response?.status) {
                case 401:
                    localStorage.setItem('currentUser', null);
                    history.push("/authentication/login");
                case 404:
                    history.push("/404");
                case 300:
                    isAsociateRecords = true;
            }
        });
}

// Esto siempre debe decir production !!!!!
function isDevelopEnvironment() {
    return environment !== "production";
}




function baseEndPoint(environmentP = appEnvironment) {
    environment = environmentP.toLowerCase();
    if (environment in apiEnv) {
        return apiEnv[environment];
    } else {
        console.log("Enviroment " + environment + " it doesn't exist");
    }
}

function baseEndPointWeb(environmentP = appEnvironment) {
    environment = environmentP.toLowerCase();
    if (environment in webEnv) {
        return webEnv[environment];
    } else {
        console.log("Enviroment " + environment + " it doesn't exist");
    }
}

function hexToRGB(h) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (h.length === 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];
        // 6 digits
    } else if (h.length === 7) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
    }
    return "rgb(" + +r + "," + +g + "," + +b + ")";
}

function hasAssociateRecords() {
    return isAsociateRecords;
}

function restartAssociateRecords() {
    isAsociateRecords = false;
}

function dateFormatter(dateValue, format = "DD/MM/YYYY") {
    if (!dateValue) {
        return "";
    }
    return `${moment(dateValue).format(format) ? moment(dateValue).format(format) : moment(dateValue).format(format)}`;
}

function datetimeFormatter(dateValue) {
    if (!dateValue) {
        return "";
    }

    return `${moment(dateValue).format("DD/MM/YYYY HH:mm:ss") ? moment(dateValue).format("DD/MM/YYYY HH:mm:ss") : moment(dateValue).format("DD/MM/YYYY HH:mm:ss")}`;
}

function calendarDateFormatter(dateValue) {
    if (!dateValue) {
        return "";
    }
    return `${moment(dateValue).format("YYYY/MM/DD") ? moment(dateValue).format("YYYY/MM/DD") : moment(dateValue).format("YYYY/MM/DD")}`;
}

function dateSeasonFormatter(dateValue) {
    let today = new Date();
    if (!dateValue) {
        return today;
    }
    dateValue = dateValue + "/" + today.getFullYear();
    return moment(dateValue, "DD/MM/YYYY").toDate();
}







